import { GraphqlWrappedData } from "../../graphql/api";

import { AddProductsToWishlistOutput, WishlistItemInput } from "../../model";

export interface BbntWishlistItemInput extends WishlistItemInput {
  productId?: string;
}

export type GraphqlResponseAddProductsToWishlist = GraphqlWrappedData<
  "addProductsToWishlist",
  AddProductsToWishlistOutput
>;

export const gqlAddProductsToWishlist = (
  wishlistItems: BbntWishlistItemInput[],
  firstWishlistId = 0
) => `
mutation {
  addProductsToWishlist(
    wishlistId: ${firstWishlistId}
    wishlistItems: [
      ${wishlistItems
        .map(
          ({ parent_sku, sku, productId, quantity }) => `
              {
                  ${parent_sku ? `parent_sku: "${parent_sku}"` : ""}
                  sku: "${sku}"
                  quantity: ${quantity}
                  ${
                    parent_sku
                      ? `selected_options: [
                      "${btoa(
                        `custom-option/super_group[${productId}]/${quantity}`
                      )}"
                  ]`
                      : ""
                  }
              }
          `
        )
        .join("")}
    ]
  ) {
    wishlist {
      id
      items_count
      items {
        id
        qty
        added_at
        bbnt_custom_wishlist_item_option {
          sku
          parent_sku
        }
        product {
          ... on GroupedProduct {
            items {
              qty
              product {
                id
                name
                cart_description
                sku
                thumbnail {
                  label
                  url
                }
                price_range {
                  maximum_price {
                    regular_price {
                      value
                    }
                    final_price {
                      value
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                  minimum_price {
                    regular_price {
                      value
                    }
                    final_price {
                      value
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                }
                price_tiers {
                  quantity
                  final_price {
                    value
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
              }
            }
          }
          thumbnail {
            label
            url
          }
          id
          name
          cart_description
          sku
          price_range {
            maximum_price {
              regular_price {
                value
              }
              final_price {
                value
              }
              discount {
                amount_off
                percent_off
              }
            }
            minimum_price {
              regular_price {
                value
              }
              final_price {
                value
              }
              discount {
                amount_off
                percent_off
              }
            }
          }
          price_tiers {
            quantity
            final_price {
              value
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
      }
    }
    user_errors {
      code
      message
    }
  }
}
`;
